module.exports = __webpack_public_path__ + "static/img/faq_service04.8f46c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service04.png
// module id = u4ba
// module chunks = 2